import { buttonVariants } from "@/lib/components/Button/button-variants";
import { cn } from "@/lib/utils";
import { ThirdPartyEditorInfoDto } from "@repo/api/third-party-video";

type Props = {
  thirdPartyEditorInfo: ThirdPartyEditorInfoDto;
};

export default function ExportThirdPartyBack({ thirdPartyEditorInfo }: Props) {
  return (
    <div className="flex flex-1 items-end justify-center self-stretch pt-20 pb-10">
      <a
        className={cn(
          buttonVariants({ variant: "outline", size: "default" }),
          "flex items-center gap-2.5",
        )}
        href={thirdPartyEditorInfo.redirectUrl}
      >
        <img
          src={thirdPartyEditorInfo.squareLogoSrc}
          alt={thirdPartyEditorInfo.displayName}
          className="h-4 w-4 object-contain object-center"
        />
        <span> {`Back to ${thirdPartyEditorInfo.displayName}`}</span>
      </a>
    </div>
  );
}
